import Countdown from 'react-countdown'

import arrowIcon from '@/assets/icons/chrismas/arrow.webp'
import hatIcon from '@/assets/icons/chrismas/hat.webp'
import { Tooltip } from '@/components/ui/tooltip'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { openDialog } from '@/models/dialogs'

import { CHRISTMAS2025_CAMPAIGN_END } from '../consts'

export const Christmas2025Promotion = () => {
  const handleOpenDialog = () =>
    openDialog({
      type: DIALOG_TYPE.CHRISTMAS_2025_PROMOTION,
    })

  // Hide component if campaign has ended
  if (Date.now() > CHRISTMAS2025_CAMPAIGN_END) {
    return null
  }

  return (
    <div className="bg-[#CC2030] p-0.5 flex items-center gap-2 sm:gap-[14px] rounded-full border-[0.5px] border-[#D8D9DD]">
      <button
        onClick={handleOpenDialog}
        className="group bg-[#0A3B0A] min-w-[140px] sm:min-w-[155px] relative px-3 sm:px-4 flex gap-1 sm:gap-2 overflow-hidden items-center h-9 rounded-full border-[1.5px] border-[#D9A473] transition-shadow hover:shadow-[0_0_8px_4px_rgba(0,87,255,0.40)_inset,0_5px_11px_0_rgba(215,58,73,0.02)]"
      >
        <img
          src={arrowIcon}
          alt="Arrow"
          className="hidden sm:block absolute left-4 h-6 top-1/2 -translate-y-1/2 -translate-x-14 group-hover:translate-x-0 sm:transition-transform duration-500"
        />
        <span className="sm:group-hover:translate-x-12 sm:transition-transform duration-500 text-sm sm:text-base lg:text-lg leading-6 text-white whitespace-nowrap">
          Claim Free Gift
        </span>
        <img
          src={hatIcon}
          alt="hat"
          className="sm:group-hover:translate-x-14 sm:transition-transform duration-500 h-5 sm:h-7"
        />
      </button>
      <Tooltip
        className="max-sm:hidden"
        content="Time remaining to claim your exclusive bundle."
      >
        <p className="text-white text-sm sm:text-base lg:text-[17px] font-medium pr-2 sm:pr-3 tabular-nums whitespace-nowrap">
          <Countdown
            intervalDelay={1000}
            autoStart
            date={CHRISTMAS2025_CAMPAIGN_END}
            renderer={({ days, hours, minutes, seconds }) =>
              [...(days > 0 ? [days] : []), hours, minutes, seconds]
                .map((item) => String(item).padStart(2, '0'))
                .join(' : ')
            }
          />
        </p>
      </Tooltip>
    </div>
  )
}
